var map = {
	"./bancointer.png": 2800,
	"./beruby.png": 3454,
	"./bitcoinback.png": 9233,
	"./cashbackworld.png": 351,
	"./cashola.png": 4652,
	"./cuponeria.png": 2980,
	"./cuponomia.png": 6193,
	"./dinvo.png": 4331,
	"./esfera.png": 2680,
	"./ganhedevolta.png": 7687,
	"./letyshops.png": 834,
	"./meliuz.png": 5420,
	"./meudimdim.png": 3926,
	"./mooba.png": 6997,
	"./mycashback.png": 8311,
	"./oisalim.png": 2717,
	"./poup.png": 5132,
	"./velupe.png": 3846,
	"./zoom.png": 3954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9158;